<script>
  import { Block, Row, Column, Text, Icon, Image } from 'bastone'
  import Header from '../components/header.svelte'
  import Page from '../components/page.svelte'
  import { bodyWidth, currentUser, notify } from '../context'
  import { ChatMessage } from '../models'
  import Confirm from '../components/confirm.svelte'
  import { onMount } from 'svelte'
  import hljs from 'highlight.js'
  import { escapeContent } from '../utils'
  import { marked } from 'marked'
  import { markedHighlight } from 'marked-highlight'
  import markedKatex from 'marked-katex-extension'

  let messageList = []
  let hasMore = true
  let loading = false
  let confirm = null

  function deleteMessage(i, message) {
    confirm.show('确定要删除收藏吗？', async()=>{
      let ok = await message.unstar()
      if (ok) {
        messageList.splice(i, 1)
        messageList = messageList
      }
    })
  }

  async function loadMore() {
    loading = true
    let lastId = messageList[messageList.length-1].star_id
    let moreData = await ChatMessage.getStarList(lastId)
    if (moreData.length > 0) {
      messageList = messageList.concat(moreData)
    } else {
      hasMore = false 
    }
    loading = false
  } 

  onMount(async ()=>{
    hljs.configure({ignoreUnescapedHTML: true})
    const renderer = new marked.Renderer();
    renderer.link = function (href, title, text) {
      return `<a target="_blank" href="${href}">${text}` + '</a>';
    }
    marked.use({breaks: true, silent: true, renderer: renderer})
    marked.use(
      markedHighlight({
        langPrefix: 'hljs language-',
        highlight(code, lang) {
          if (hljs.getLanguage(lang)) {
            return hljs.highlight(code, {language:lang}).value
          } else {
            return hljs.highlightAuto(code).value
          }
        }
      })
    )
    marked.use(markedKatex({throwOnError: false, strict: false}))

    ChatMessage.getStarList().then(res=>{
      if (res) messageList = res
    }) 
    
    window.addEventListener('scroll', ()=>{
      if (!hasMore || loading || messageList.length == 0) return
      let html = document.documentElement
      if (html.scrollTop + html.clientHeight >= html.scrollHeight-1) {
        loadMore()
      }
    })
  })
</script>

<svelte:head>
  <link rel="stylesheet" href="/highlight/styles/github-dark-dimmed.min.css">
</svelte:head>


<Confirm bind:this={confirm}/>
<Page title=收藏夹>
  <Header buttonType='back'/>
  <Block minHeight=1.2rem/>
  <Row align=center width={$bodyWidth}  maxWidth=100%>
    <Column width=100% maxWidth=60rem>
      <Row>
        <Text size=1.1rem bold=1>{$currentUser?.name || '我'}的收藏夹</Text>
      </Row>
      <Block height=1rem/>
      {#each messageList as message, i}
      <Block border=1>
        <Block height=0.9rem/>
        <Row>
          <Block width=1rem/>
          <Image height=2rem url={message.role=='user'?message.user_avatar:message.bot.avatar_url}/>
          <Block width=0.6rem/>
          <Column>
            <Text size=1.1rem bold=1>{message.role=='user'?message.user_name:message.bot.name}</Text>
            <Block height=0.1rem/>
          </Column>
          <Block expand=1/>
          <Row height=2rem xAlign=flex-start>
            <Icon
              name=copy size=1.2rem cursor=pointer
              on:click={()=>{navigator.clipboard.writeText(message.content);notify('已复制')}}
            />
            <Block width=0.4rem/>
            <Icon 
              name=ashbin size=1.2rem cursor=pointer
              on:click={()=>deleteMessage(i,message)}
            />
          </Row>
          <Block width=0.6rem/>
        </Row>
        <Block height=0.8rem/>
        <Row>
          <Block minWidth=1rem/>
          <Text 
            wrap=1 size=1.05rem lineHeight=1.6rem width=100%
          >{@html marked.parse(escapeContent(message.content))}</Text>
          <Block minWidth=1rem/>
        </Row>
        <Block height=0.8rem/>
      </Block>
      <Block height=1rem/>
      {/each}
    </Column>
  </Row>
</Page>
